import { withNamespaces } from "react-i18next";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";

const ResendInvitationEmailModal = ({
    t,
    isOpen,
    closeModal,
    onConfirm,
    isLoading
}) => {
    return (
        <Modal isOpen={isOpen}>
            <ModalHeader>
                {t('Resend Invitation Email')}
            </ModalHeader>
            <ModalBody>
                {t('Are you sure you want to resend the invitation email to this user? This will send a new invitation to their registered email address so they can set their password and access the platform.')}
            </ModalBody>
            <ModalFooter>
                <Button 
                    color="secondary" 
                    onClick={closeModal}
                >
                    {t('Cancel')}
                </Button>
                <Button 
                    color="primary" 
                    onClick={onConfirm}
                    disabled={isLoading}
                >
                    {isLoading && (
                        <Spinner 
                            color="white"
                            size="sm"
                            className="me-1"
                        />
                    )}
                    {t('Resend Invitation')}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default withNamespaces()(
    ResendInvitationEmailModal
);